import { apiNotifications } from "@/api/notification.api.ts";
import { applicantsKeys } from "@/queries/recruit/use-applicants.query.ts";
import { ApiAction } from "@/types/action.types.ts";
import { useQueryClient } from "@tanstack/react-query";

export function useNotificationHook() {
  const queryClient = useQueryClient();

  const readActionsNotification = (actions?: ApiAction[]) => {
    if (!actions?.length) return;

    const notifications = actions
      .map((action) => action.comment_data?.notification)
      .filter(Boolean);

    if (!notifications.length) return;

    Promise.all(
      notifications.map((notification) => apiNotifications.markAsRead(notification!.id, true))
    ).then(() => {
      queryClient.invalidateQueries({
        queryKey: applicantsKeys.mentions().queryKey,
      });
      queryClient.invalidateQueries({
        queryKey: applicantsKeys.search._def,
      });
      queryClient.invalidateQueries({
        queryKey: applicantsKeys.searchInfinite._def,
      });
    });
  };

  return { readActionsNotification };
}
